"use client";
import type { MouseEvent as ReactMouseEvent, PointerEvent as ReactPointerEvent, ReactElement, ReactNode, RefObject, } from "react";
import { Cscrollable } from "../Cscrollable";
import { SCROLL_FADE_WIDTH } from "./timeline-constants";
const SCROLL_DIRECTION_HORIZONTAL = "horizontal";
export interface TimelineScrollShellProps {
    children: ReactNode;
    onMouseEnter: (event: ReactMouseEvent<HTMLDivElement>) => void;
    onMouseLeave: () => void;
    onMouseMove: (event: ReactMouseEvent<HTMLDivElement>) => void;
    onPointerDown: (event: ReactPointerEvent<HTMLDivElement>) => void;
    scrollContainerRef: RefObject<HTMLDivElement | null>;
    viewportHeight: number;
}
export function TimelineScrollShell({ children, onMouseEnter, onMouseLeave, onMouseMove, onPointerDown, scrollContainerRef, viewportHeight, }: TimelineScrollShellProps): ReactElement {
    return (
      <div data-el="Cmarkdowntimeline/TimelineScrollShell/Root" onMouseEnter={onMouseEnter} onMouseMove={onMouseMove} onMouseLeave={onMouseLeave} onPointerDown={onPointerDown} style={{
            position: "relative",
            height: viewportHeight,
            marginTop: 0,
        }}>
        <Cscrollable dataElScope="Cmarkdowntimeline/TimelineScrollShell" direction={SCROLL_DIRECTION_HORIZONTAL} fadeSize={SCROLL_FADE_WIDTH} firstItemSpacing={0} scrollRef={scrollContainerRef} style={{
            position: "relative",
            height: "100%",
            overflowY: "auto",
            paddingTop: 0,
            paddingRight: 0,
        }}>
          {children}
        </Cscrollable>
      </div>
    );
}
